import React from 'react';
import { AlertCircle, Package, RefreshCw } from 'lucide-react';

export function LoadingState({ label = 'Loading...' }) {
  return (
    <div className="state-box">
      <div className="spinner" style={{ width: 34, height: 34 }} />
      <div className="state-title">{label}</div>
    </div>
  );
}

export function EmptyState({ title, message, actionLabel, onAction }) {
  return (
    <div className="state-box">
      <Package size={44} color="var(--gray-border)" />
      <div className="state-title">{title}</div>
      {message && <div className="state-subtitle">{message}</div>}
      {actionLabel && onAction && (
        <button onClick={onAction} className="btn-primary" style={{ marginTop: 10, padding: '9px 16px' }}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export function ErrorState({ title = 'Something went wrong', message, onRetry }) {
  return (
    <div className="state-box state-box-error">
      <AlertCircle size={42} color="var(--red)" />
      <div className="state-title">{title}</div>
      {message && <div className="state-subtitle">{message}</div>}
      {onRetry && (
        <button onClick={onRetry} className="btn-outline" style={{ marginTop: 10, padding: '8px 14px' }}>
          <RefreshCw size={14} /> Retry
        </button>
      )}
    </div>
  );
}
